import A from './analytics';
import { loadScript } from './utils';

export const deferInstallPrompt = () => {
  // Capture Install prompt on page load and save for later
  window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault();

    window.deferredPrompt = e;
    return false;
  });
};

export const captureGlobalErrors = () => {
  window.onerror = (err, url, line, col, error) => {
    try {
      const e = JSON.stringify({ err, url, line, col, error });
      A.logError(e);
    } catch (err) {
      A.logError(err);
    }
  };
};

export const disableConsole = () => {
  // Disable console logging in production mode
  if (process.env.NODE_ENV === 'production') {
    window.console.log = window.console.info = window.console.warn = () => null;

    window.console.error = err => A.logError(typeof err === 'object' ? JSON.stringify(err) : err);
  }
};

export const logLoadTime = () => {
  if (window.BP_LOAD_TIME) {
    const time = Date.now() - window.BP_LOAD_TIME;
    A.timer('LOAD_TIME', 'PAGE_LOAD', time);
  }
};

export const loadLazyLoader = () => {
  const version = !('IntersectionObserver' in window) ? '8.15.0' : '10.15.0'; // Use version compatible with browser
  loadScript(`/js/lazyload/lazyload${version}.min.js`).then(() => {
    if (window.LazyLoad) {
      window.ll = new window.LazyLoad({
        elements_selector: '.lazy',
        threshold: 50,
      });
    } else {
      window.alert('Slow Network. Images may not be displayed.');
    }
  });
};

export const loadFacebookSdk = () => {
  window.addEventListener('load', () => {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: '1929422550475332',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v3.1',
      });
    };

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  });
};

export const initHotjar = () => {
  (function(h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function() {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 1589720, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
};

export const initBranch = () => {
  // load Branch
  (function(b, r, a, n, c, h, _, s, d, k) {
    if (!b[n] || !b[n]._q) {
      for (; s < _.length; ) c(h, _[s++]);
      d = r.createElement(a);
      d.async = 1;
      d.src = 'https://cdn.branch.io/branch-latest.min.js';
      k = r.getElementsByTagName(a)[0];
      k.parentNode.insertBefore(d, k);
      b[n] = h;
    }
  })(
    window,
    document,
    'script',
    'branch',
    function(b, r) {
      b[r] = function() {
        b._q.push([r, arguments]);
      };
    },
    { _q: [], _v: 1 },
    'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking'.split(
      ' '
    ),
    0
  );
  // init Branch
  window.branch.init('key_live_mpUHxrOc38xcfhpmiolxualkwBjVkGHN');
};

export const initSnapchatPixelTracker = (userEmail = 'anonymous') => {
  (function(e,t,n){
    if(e.snaptr)return;
    var a=e.snaptr=function() {
      a.handleRequest ? a.handleRequest.apply(a,arguments):a.queue.push(arguments)
    };
    a.queue=[];
    var s='script'; 
    var r=t.createElement(s);
    r.async=!0;
    r.src=n;
    var u=t.getElementsByTagName(s)[0];
    u.parentNode.insertBefore(r,u);
  })(window,document, 'https://sc-static.net/scevent.min.js');

  // // eslint-disable-next-line no-undef
  // snaptr('init', 'eed0d32f-6280-45d8-8af6-4b5f47c601f5', {
  //       'user_email': userEmail
  //   });

  //   console.log('SNAPCHAT CODE LOADED SUCCESSFULLY')
  // // eslint-disable-next-line no-undef
  // snaptr('track', 'PAGE_VIEW');
};

export const snapchatTrack = (userEmail) => {
  try {
    window.snaptr('init', 'eed0d32f-6280-45d8-8af6-4b5f47c601f5', {
      'user_email': userEmail
  });
  window.snaptr('track', 'PAGE_VIEW');
} catch (error) {
  console.error('SNAPCHAT PIXEL ERROR', error)
}
}



// WEBPACK FOOTER //
// ./src/start.js